import React, { useState, useMemo, useEffect } from 'react'
import classes from './Table.module.css';

import { useReactTable, getCoreRowModel, flexRender, getPaginationRowModel, Pagination, getSortedRowModel, getFilteredRowModel } from '@tanstack/react-table';

import PaginationControls from './PaginationControls';
import { Navigate, useNavigate } from 'react-router-dom';

import useSetCookie from '../../hooks/UseSetCookie';
import { serviceActions } from '../../../store/service-Slice';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

const BasicTable = ({ data, columns, allColumns, ShowPagination, filtering, rowClick, PageSize, setPageSize, paginationOptions, tableClasses, showFilterButton, setExportData, exportFormatFunction, isSortable, onPageRowsChange }) => {
  const hiddenColumns1 = ['Users', 'Initial Activation', 'Firmware', 'IP Address',]; // Names of columns to hide
  const hiddenColumns2 = ['Users', 'Initial Activation', 'Firmware', 'IP Address', 'Tag']; // Names of columns to hide
  let [filteredColumns, setFilteredColumns] = useState(columns)

  const [columnVisibility, setColumnVisibility] = useState({});

  useEffect(() => {
    // Function to handle changes in the first media query
    const handleIsMobile1 = () => {
      if (window.innerWidth > 600 && window.innerWidth <= 1050) {
        // Filter out hidden columns for <= 1050px
        setFilteredColumns(columns.filter(column => !hiddenColumns1.includes(column.header)));
      } else if (window.innerWidth <= 600) {
        // Filter out additional hidden columns for <= 600px
        setFilteredColumns(columns.filter(column => !hiddenColumns2.includes(column.header)))
      } else {
        // Show all columns for > 1050px
        setFilteredColumns(columns);
      }
    };

    // Initial check for if screen has been resized
    handleIsMobile1();

    // Add event listeners for changes in the media queries
    window.addEventListener('resize', handleIsMobile1);


    // Clean up by removing event listeners when component unmounts
    return () => {
      window.removeEventListener('resize', handleIsMobile1);

    };
  }, [columns]);

  // const [showPagination, setShowPagination] = useState(ShowPagination && true);
  //const [pageSize, setPageSize] = useState(PageSize || 25);


  const [sorting, setSorting] = useState([])
  const table = useReactTable({
    data,
    columns: filteredColumns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting: sorting,
      // sorting: [{ id: 'tag', desc: true }],
      globalFilter: filtering ? filtering : undefined,
      columnVisibility
    },
    onSortingChange: setSorting,
    onColumnVisibilityChange: setColumnVisibility,
  });

  useEffect(() => {
    console.log(data);
    if (setExportData && exportFormatFunction) {
      const rows = table.getFilteredRowModel().rows;
      setExportData(rows.map(row => exportFormatFunction(row.original)));
    }
  }, [data, filtering])


  {/* Set the page size manually  */ }
  useEffect(() => {
    table.setPageSize(PageSize)

  }, [table, PageSize]);

  const pageRows = table.getRowModel().rows;
  useEffect(() => {
    if (onPageRowsChange) {
      onPageRowsChange(pageRows.map(r => r.original));
    }
  }, [pageRows]);

  const navigate = useNavigate();
  const setcookie = useSetCookie();
  const dispatch = useDispatch();

  const handleRowClick = (row) => {
  };

  const handleColumnVisibilityChange = (columnId, isVisible) => {
    // Get the current visibility settings
    const currentVisibility = JSON.parse(localStorage.getItem('columnVisibility')) || {};
    // Update visibility for the specific column
    const updatedVisibility = { ...currentVisibility, [columnId]: isVisible };
    // Save updated settings to local storage
    localStorage.setItem('columnVisibility', JSON.stringify(updatedVisibility));
  };


  const [columnSettingsVisible, setColumnSettingsVisible] = useState(false)
  return (
    <>
      <div className={(tableClasses && tableClasses["w3-container"]) || (classes && classes["w3-container"])}>
        {/* Column Visibility Fitler   */}
        {showFilterButton &&
          <>
            <div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "10px" }}>
              <Button
                icon="pi pi-table"
                text
                severity="secondary"
                onClick={() => setColumnSettingsVisible(true)}
                title="Show/hide columns"
                style={{ padding: "4px 8px" }}
              />
            </div>

            <Dialog
              header="Column visibility"
              visible={columnSettingsVisible}
              style={{ width: "360px" }}
              onHide={() => setColumnSettingsVisible(false)}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {table.getAllLeafColumns().map(column => {
                  const isVisible = column.getIsVisible();
                  return (
                    <div key={column.id} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Checkbox
                        inputId={`col-${column.id}`}
                        checked={isVisible}
                        onChange={() => {
                          column.toggleVisibility(!isVisible); // Update table state
                          handleColumnVisibilityChange(column.id, !isVisible); // Persist to localStorage
                        }}
                      />
                      <label htmlFor={`col-${column.id}`} style={{ cursor: "pointer", fontSize: "14px" }}>
                        {column.columnDef.filterLabel || 'Unnamed Column'}
                      </label>
                    </div>
                  )
                })}
              </div>
            </Dialog>
          </>}
        <table className={(tableClasses && tableClasses["w3-table-all"]) || (classes && classes["w3-table-all"])}>
          <thead />
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <th
                  key={header.id}
                  style={header.column.columnDef.meta?.style}
                  onClick={isSortable ? header.column.getToggleSortingHandler() : null}>
                  <div>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    {
                      { asc: ' 🔼', desc: ' 🔽' }[header.column.getIsSorted() ?? null
                      ]
                    }
                  </div>
                  
                </th>
              ))}
            </tr>
          ))}
          <thead />
          <tbody>
          {table.getRowModel().rows.map(row => {
            // User rows are identified by having an email, so site rows aren't affected
            const isUserRow = row.original.email != null && row.original.email !== "";
            const isUserSuspended = isUserRow && row.original.suspended == 1 && (row.original.portalAccess == "" || row.original.portalAccess == null);
            const isSiteRestricted = !isUserRow && (row.original.suspended === 1) && (row.original.key !== "" && row.original.key !== null) && row.original.active === 1;
            const isSiteInactive = (row.original.suspended == null || row.original.suspended === "") && row.original.active === 0;
            const isInactive = (row.original.active == 0)
            const isIonDevice = row.original.type === "A" || row.original.type === "AB" || row.original.type === "ESP";
            const isDimmed = isUserSuspended || isSiteRestricted || isSiteInactive || isInactive;

            return (
              <tr
                key={row.id}
                onClick={() => rowClick ? handleRowClick(row) : ""}
                className={isDimmed ? classes.suspendedRow : ""}
                title={isUserSuspended ? "User suspended" : isSiteRestricted ? "Site restricted" : isSiteInactive ? "Site inactive" : ""}
                style={isIonDevice ? { outline: "2px solid #5fdc8d", outlineOffset: "-1px", borderRadius: "6px" } : undefined}
              >
                {row.getVisibleCells().map(cell => (
                  <td
                    key={cell.id}
                    style={cell.column.columnDef.meta?.style}
                    className={isDimmed && !cell.column.columnDef.meta?.exemptFromDim ? classes.suspendedCell : ""}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
        </table>
        {ShowPagination && table.getFilteredRowModel().rows.length > 10 && <PaginationControls paginationOptions={paginationOptions} table={table} PageSize={PageSize} setPageSize={setPageSize} />}
      </div>
    </>
  );
}

export default BasicTable;